import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { BalanceSheetPage } from '../../features/reports/balance-sheet-page'
import { balanceSheetSearchSchema } from '../../features/reports/search'

export const Route = createFileRoute('/_app/balance-sheet')({
  staticData: { crumb: 'balanceSheet' },
  validateSearch: balanceSheetSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'reports.financial'),
  component: BalanceSheetPage,
})
